/**
 * legal_date 编辑器：targeting_id="1、2、3、4、5"（周几）+ ext_info=JSON
 * {holiday:[yyyyMMdd], leave_in_lieu:[yyyyMMdd]}。
 * 周几复选 + 两组多日期 chips（节假日 / 调休上班日）。
 */
import type { EditorProps } from "./types";
import type { EditorChange } from "./types";
import { WeekdayCheckboxes } from "./WeekdayCheckboxes";
import { MultiDateChips } from "./MultiDateChips";
import { joinDy, parseJsonExt, splitDy, stringifyJsonExt } from "../../utils/redlineHelpers";

interface LegalDateExt {
  holiday?: number[];
  leave_in_lieu?: number[];
}

export function LegalDateEditor({ item, onChange }: EditorProps) {
  const weekdays = splitDy(item.targeting_id)
    .map((t) => Number(t))
    .filter((n) => Number.isInteger(n));
  const ext = parseJsonExt<LegalDateExt>(item.ext_info, {});
  const holiday = ext.holiday ?? [];
  const leave = ext.leave_in_lieu ?? [];

  function setWeekdays(next: number[]) {
    const c: EditorChange = {
      targeting_id: joinDy(next.map(String)),
      ext_info: item.ext_info ?? "",
    };
    onChange(c);
  }

  function setHoliday(next: number[]) {
    onChange({
      targeting_id: item.targeting_id,
      ext_info: stringifyJsonExt({ holiday: next, leave_in_lieu: leave }),
    });
  }

  function setLeave(next: number[]) {
    onChange({
      targeting_id: item.targeting_id,
      ext_info: stringifyJsonExt({ holiday: holiday, leave_in_lieu: next }),
    });
  }

  return (
    <div className="space-y-3">
      <div className="rl-subbox">
        <div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-text-strong">
          可投放周几
        </div>
        <WeekdayCheckboxes selected={weekdays} onChange={setWeekdays} />
      </div>
      <div className="rl-subbox">
        <MultiDateChips
          label="非周末放假日期（holiday，不投放）"
          dates={holiday}
          onChange={setHoliday}
        />
      </div>
      <div className="rl-subbox">
        <MultiDateChips
          label="调休上班日（leave_in_lieu，照常投放）"
          dates={leave}
          onChange={setLeave}
        />
      </div>
    </div>
  );
}
